import "./style.scss";

import { Spinner } from "components/shared/Spinner";
import { formatMaintenanceRange } from "helpers/maintenanceTime";
import { useTranslation } from "react-i18next";

type MaintenanceScreenProps = {
    startsAt?: string | null;
    endsAt?: string | null;
    title?: string | null;
    description?: string | null;
    /** When set, the refresh control does not reload the page. Used by the admin preview. */
    onRefresh?: () => void;
    /** Crealo admin leaves the screen and opens settings. */
    onBypass?: () => void;
};

const MaintenanceScreen = ({ startsAt, endsAt, title, description, onRefresh, onBypass }: MaintenanceScreenProps) => {
    const { t } = useTranslation();
    const range = startsAt && endsAt ? formatMaintenanceRange(startsAt, endsAt) : null;
    const heading = title?.trim() ? title : t("Maintenance.Title");
    const body = description?.trim() ? description : t("Maintenance.Body");

    return (
        <div className="maintenance-screen">
            {onBypass && (
                <div className="maintenance-screen-banner">
                    <p>{t("Maintenance.BypassNote")}</p>
                    <button type="button" onClick={onBypass}>
                        {t("Maintenance.Bypass")}
                    </button>
                </div>
            )}
            <div className="maintenance-screen-body">
                <div className="maintenance-screen-content">
                    <div className="maintenance-screen-mark" aria-hidden>
                        <Spinner size={44} />
                    </div>
                    <h1>{heading}</h1>
                    {range && (
                        <p className="maintenance-screen-range">
                            {t(range.sameDay ? "Maintenance.TimeRange" : "Maintenance.TimeRangeDays", {
                                ...range,
                                timeZone: t("Maintenance.TimeZone"),
                            })}
                        </p>
                    )}
                    <p className="maintenance-screen-text">{body}</p>
                    <button
                        type="button"
                        className="maintenance-screen-refresh"
                        onClick={onRefresh ?? (() => window.location.reload())}
                    >
                        {t("Maintenance.Retry")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MaintenanceScreen;
